import { useEffect } from 'react';
import { useAppliedTheme } from '../shared/store/themeStore';
import { useTheme } from '../shared/hooks/useTheme';

// Theme provider for managing theme classes (compatible with Tailwind)
export function YodaThemeProvider({ children }: { children: React.ReactNode }) {
  // Initialize theme system
  useTheme();
  const appliedTheme = useAppliedTheme();

  // Add theme classes to body and html for both custom and Tailwind dark mode
  useEffect(() => {
    const themeClass = `theme-${appliedTheme}`;

    // Remove previous theme classes
    document.body.classList.remove('theme-light', 'theme-dark');
    document.body.classList.add(themeClass);

    // Add 'dark' class to html element for Tailwind dark mode
    if (appliedTheme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }

    return () => {
      document.body.classList.remove(themeClass);
      document.documentElement.classList.remove('dark');
    };
  }, [appliedTheme]);

  return <>{children}</>;
}
